module.exports = __webpack_public_path__ + "img/hc-icon02.7e643753.svg";